import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { MultiSiteGuard } from '../guards/multi-site.guard';
import { lazyRoute } from '../lazy-route';

export const mySitesRoutes: RouteObject[] = [
  {
    path: RoutesList.MY_SITES,
    element: <MultiSiteGuard />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRoute(() => import('../../pages/my-sites/my-sites-page')),
          },
          {
            path: ':tenantId',
            ...lazyRoute(() => import('../../pages/my-sites/my-site-detail-page')),
          },
        ],
      },
    ],
  },
];
